// extracted by mini-css-extract-plugin
export var bubble = "_3m-0";
export var container = "_3m-3";
export var contrastBorder = "_3m-4";
export var greyOut = "_3m-2";
export var initialsWrapper = "_3m-1";
export var large = "_3m-9";
export var medium = "_3m-8";
export var mediumSmall = "_3m-7";
export var mediumSmallMedium = "_3m-c";
export var micro = "_3m-5";
export var small = "_3m-6";
export var tiny = "_3m-b";
export var xTiny = "_3m-a";